import React, { useState, useRef, useEffect } from 'react';
import useStores from 'hooks/useStore';
import { observer } from 'mobx-react-lite';
import ImageModal from 'components/ImageModal';
import Select from 'react-select';
import { withAuctionCore } from 'agent';
import NoDataTabs from 'components/common/NoDataTabs';
import moment from 'moment';

import useSortableData from 'hooks/useSortableData';

import useResponsive from 'hooks/useResponsive';
import useOnClickOutside from 'hooks/useClickOutside';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VehicleItem from './VehicleItem';
import {
  Wrapper,
  Header,
  Title,
  Table,
  Row,
  Column,
  LeftActions,
  TableHead,
  TableHeadText,
  Lightbox,
  RightAction,
  RightActions,
  TooltipText,
  TooltipBox,
  TooltipCard,
} from './styles';
import useReports from '../../hooks/useReports';

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white', marginBottom: 0 }),
  option: (styles, {
    isFocused,
  }) => ({
    ...styles,
    color: 'black',
    textAlign: 'left',
    backgroundColor: isFocused ? '#ccc' : null,
  }),
};

const RecentlySold = observer(({ auctioncore }) => {
  const {
    setReports,
  } = useReports(auctioncore);
  const { UIStore } = useStores();
  const {
    selectedStartDate, selectedEndDate, highlightedUnit, setHighlightedUnit, condition, vehicleComparables,
  } = UIStore;
  const { isLargeView } = useResponsive();

  const ref = useRef();

  useOnClickOutside(ref, () => setHighlightedUnit(null));

  const { items, requestSort, sortConfig } = useSortableData(vehicleComparables, selectedStartDate, moment(selectedEndDate).add(1, 'M').toDate());

  const [showUnitPreview, setShowUnitPreview] = useState(false);
  const [showImageCarousel, setShowImageCarousel] = useState(false);
  const [imageArray, setImageArray] = useState(false);

  const handleToggleImageModal = () => {
    if (showImageCarousel) {
      setShowImageCarousel(false);
      setShowUnitPreview(true);
      return;
    }

    setShowImageCarousel(true);
    setShowUnitPreview(false);
  };

  const GetFeaturedVehicle = (id) => {
    if (vehicleComparables) {
      const units = vehicleComparables.filter((item) => item.vehicleID === id);

      if (units.length) {
        return units[0];
      }
    }

    return null;
  };

  const WhichSortIcon = (field) => {
    if (sortConfig?.key === field) {
      if (sortConfig?.direction === 'ascending') {
        return 'sort-up';
      }

      return 'sort-down';
    }

    return 'sort';
  };

  const HighlightSortOption = (val, label) => (
    <div>
      {label}
      {' '}
      {sortConfig?.key === val && <FontAwesomeIcon size="1x" icon="sort" color="#ce2600" />}
    </div>
  );

  useEffect(() => {
    console.log('use effect > tom', condition);
    setReports(condition, false, false, true).then(() => requestSort('saleDate'));
  }, []);

  if (items.length < 1) {
    return <NoDataTabs />;
  }

  return (
    <Wrapper>
      {highlightedUnit
      && (
      <Table>
        <VehicleItem
          item={GetFeaturedVehicle(highlightedUnit)}
          setShowImageCarousel={setShowImageCarousel}
          setImageArray={setImageArray}
          highlight
          customRef={ref}
        />
        <Lightbox />
      </Table>
      )}

      {vehicleComparables[0] && imageArray && <ImageModal setShowImageCarousel={handleToggleImageModal} images={imageArray} visible={showImageCarousel} />}
      <Header>

        <Title>
          <span>{items.length}</span>
          {' '}
          Results
        </Title>

        <RightActions>
          <RightAction>
            <Select
              isClearable
              styles={colourStyles}
              placeholder="Sort"
              isSearchable={false}
              onChange={(e) => requestSort(e ? e.value : 'saleDate')}
              options={[
                {
                  label: HighlightSortOption('score', 'Score'),
                  value: 'score',
                },
                {
                  label: HighlightSortOption('location', 'Location'),
                  value: 'location',
                },
                {
                  label: HighlightSortOption('mileage', 'Miles/Hours'),
                  value: 'mileage',
                },
                {
                  label: HighlightSortOption('saleAmount', 'Sale Amount'),
                  value: 'saleAmount',
                },
                {
                  label: HighlightSortOption('saleDate', 'Sale Date'),
                  value: 'saleDate',
                },
                {
                  label: HighlightSortOption('color', 'Color'),
                  value: 'color',
                },
              ]}
            />
          </RightAction>
        </RightActions>
      </Header>

      <Table>
        {isLargeView && (
        <Row>
          <Column />
          <Column>
            <TableHead onClick={() => requestSort('score')}>
              <TableHeadText>Score</TableHeadText>
              <FontAwesomeIcon size="1x" icon={WhichSortIcon('score')} color={sortConfig?.key === 'score' ? '#ce2600' : 'white'} />
            </TableHead>
          </Column>
          <Column>
            <TableHead>
              <TableHeadText>
                <TooltipCard>
                  <TooltipText>
                    EM / FR / TR
                    <FontAwesomeIcon icon="question-circle" />
                  </TooltipText>
                  <TooltipBox>
                    <p>EM - Engine Mechanical</p>
                    <p>FR - Frame</p>
                    <p>TR - Transmission</p>
                  </TooltipBox>
                </TooltipCard>
              </TableHeadText>
            </TableHead>
          </Column>
          <Column>

            <TableHead onClick={() => requestSort('mileage')}>
              <TableHeadText>Miles/Hours</TableHeadText>
              <FontAwesomeIcon size="1x" icon={WhichSortIcon('mileage')} color={sortConfig?.key === 'mileage' ? '#ce2600' : 'white'} />
            </TableHead>
          </Column>
          <Column>
            <TableHead onClick={() => requestSort('saleAmount')}>
              <TableHeadText>Amount</TableHeadText>
              <FontAwesomeIcon size="1x" icon={WhichSortIcon('saleAmount')} color={sortConfig?.key === 'saleAmount' ? '#ce2600' : 'white'} />
            </TableHead>

          </Column>
          <Column>
            <TableHead onClick={() => requestSort('saleDate')}>
              <TableHeadText>Sale Date</TableHeadText>
              <FontAwesomeIcon size="1x" icon={WhichSortIcon('saleDate')} color={sortConfig?.key === 'saleDate' || !sortConfig?.key ? '#ce2600' : 'white'} />
            </TableHead>
          </Column>
          <Column>
            <TableHead onClick={() => requestSort('location')}>
              <TableHeadText>Location</TableHeadText>
              <FontAwesomeIcon size="1x" icon={WhichSortIcon('location')} color={sortConfig?.key === 'location' ? '#ce2600' : 'white'} />
            </TableHead>
          </Column>
          <Column>
            <TableHead onClick={() => requestSort('color')}>
              <TableHeadText>Color</TableHeadText>
              <FontAwesomeIcon size="1x" icon={WhichSortIcon('color')} color={sortConfig?.key === 'color' ? '#ce2600' : 'white'} />
            </TableHead>
          </Column>
        </Row>
        )}

        {items.map((item, i) => (
          <VehicleItem
            key={i}
            item={item}
            setShowImageCarousel={setShowImageCarousel}
            setImageArray={setImageArray}
          />
        ))}

      </Table>
    </Wrapper>
  );
});

export default withAuctionCore(RecentlySold);
